import { render } from "./EventPreview.vue?vue&type=template&id=485fe170"
import script from "./EventPreview.vue?vue&type=script&lang=js"
export * from "./EventPreview.vue?vue&type=script&lang=js"

import "./EventPreview.vue?vue&type=style&index=0&id=485fe170&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__